import { render, staticRenderFns } from "./updateDialog.vue?vue&type=template&id=5464652e"
import script from "./updateDialog.vue?vue&type=script&lang=ts"
export * from "./updateDialog.vue?vue&type=script&lang=ts"
import style0 from "./updateDialog.vue?vue&type=style&index=0&id=5464652e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports